import { useEffect, useRef, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Public Pages
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import OrderForm from "@/pages/OrderForm";
import Dashboard from "@/pages/Dashboard";
import OrderView from "@/pages/OrderView";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminClients from "@/pages/admin/AdminClients";
import AdminClientDetail from "@/pages/admin/AdminClientDetail";
import AdminVehicles from "@/pages/admin/AdminVehicles";
import AdminVehicleDetail from "@/pages/admin/AdminVehicleDetail";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminInvoiceDetail from "@/pages/admin/AdminInvoiceDetail";
import AdminServices from "@/pages/admin/AdminServices";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminBillingSettings from "@/pages/admin/AdminBillingSettings";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance with credentials
export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
});

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check URL fragment for session_id SYNCHRONOUSLY during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
      <Route path="/servicii" element={<><Navbar /><Services /><Footer /></>} />
      <Route path="/comanda" element={<><Navbar /><OrderForm /><Footer /></>} />
      <Route path="/despre-noi" element={<><Navbar /><About /><Footer /></>} />
      <Route path="/contact" element={<><Navbar /><Contact /><Footer /></>} />
      <Route path="/termeni-conditii" element={<><Navbar /><Terms /><Footer /></>} />
      <Route path="/politica-confidentialitate" element={<><Navbar /><Privacy /><Footer /></>} />
      <Route path="/autentificare" element={<Login />} />
      
      {/* Protected client routes */}
      <Route path="/cont" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/cont/comanda/:orderId" element={
        <ProtectedRoute>
          <OrderView />
        </ProtectedRoute>
      } />

      {/* Admin routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="clients" element={<AdminClients />} />
        <Route path="clients/:clientId" element={<AdminClientDetail />} />
        <Route path="vehicles" element={<AdminVehicles />} />
        <Route path="vehicles/:vehicleId" element={<AdminVehicleDetail />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="orders/:orderId" element={<AdminOrderDetail />} />
        <Route path="invoices" element={<AdminInvoices />} />
        <Route path="invoices/:invoiceId" element={<AdminInvoiceDetail />} />
        <Route path="services" element={<AdminServices />} />
        <Route path="billing-settings" element={<AdminBillingSettings />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
